import React from "react";
import Status from "@ingka/status";
import { ListViewItem } from "@ingka/list-view";
import { useTranslation } from "@coworker/locales";
import { useAvailableElevatedStock } from "../../../hooks/useAvailableElevatedStock";
import {
  getStockStatusIcon,
  getStockStatusIndicatorColor,
  getStockStatusText,
} from "./ArticleStock.helper";

interface ArticleStockProps {
  productArticleId: string;
  productArticleType: string;
}

export const ArticleStock = ({
  productArticleId,
  productArticleType,
}: ArticleStockProps) => {
  const { t } = useTranslation();

  const fullId = `${productArticleType}${productArticleId}`;
  const { available, elevated, loading } = useAvailableElevatedStock(fullId);

  const stockStatusColor = getStockStatusIndicatorColor(available, elevated);
  const stockStatusText = getStockStatusText(available, elevated);
  const stockStatusIcon = getStockStatusIcon(available, elevated);

  const addOnContent = loading ? (
    t("loadingString")
  ) : (
    <Status
      label={`${available} (${elevated})`}
      statusColor={stockStatusColor}
      small
    />
  );

  return (
    <ListViewItem
      title={t("statusString")}
      description={t(stockStatusText)}
      leadingIcon={stockStatusIcon}
      addOn={addOnContent}
      emphasised
      inset
    />
  );
};
